/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2024
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import React, { createContext, useContext, useReducer } from 'react';
import baselineConfigReducer from './BaselineConfigReducer';
import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';

export interface IIndepVarFormData {
  checked?: boolean;
  inputValue?: string | { from: Date; to: Date } | null;
}

export interface IBaselineConfigState {
  formData: { [key: string]: IIndepVarFormData };
}

const initialState: IBaselineConfigState = {
  formData: {}
};

export const BaselineConfigContext = createContext<IAny>(initialState);

export const BaselineConfigProvider: React.FC<{}> = ({ children }) => {
  const [state, dispatch] = useReducer(baselineConfigReducer, initialState);

  const value: IAny = [state, dispatch];

  return (
    <BaselineConfigContext.Provider value={value}>
      {children}
    </BaselineConfigContext.Provider>
  );
};

export const useBaselineConfigContext = () => useContext(BaselineConfigContext);
